import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Layout } from 'antd'
import Sidebar from '../sidebar'
import { FunctionalErrorBoundary } from '@/shared/lib/error-boundary'
import Header from '../header'
import AppRoutes from '../../root/Auth/AppRoutes'
import { LogoGlassProIcon } from '@/shared/ui/icons'

const MemoizedSidebar = memo(Sidebar)
const MemoizedHeader = memo(Header)

const DynamicLayout = () => {
  const { pathname } = useLocation()
  const [collapsed, setCollapsed] = useState(false)

  const handleToggle = useCallback(() => {
    setCollapsed((prev) => !prev)
  }, [])

  const showSidebar = !['/login', '/'].includes(pathname)
  const isMainPages = pathname === '/'

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', collapsed ? '64px' : '250px')
  }, [collapsed])

  const gridCols = useMemo(() => {
    if (isMainPages) return '1fr'
    if (showSidebar) return collapsed ? '64px 1fr' : '250px 1fr'
    return '1fr'
  }, [isMainPages, showSidebar, collapsed])

  const isLogin = pathname === '/login'

  return (
    <Layout
      className={`h-screen max-w-[100vw] grid transition-all duration-300 ease-in-out ${
        isMainPages ? 'px-6 bg-white' : 'bg-(--background)'
      }`}
      style={{ gridTemplateColumns: gridCols }}
    >
      {showSidebar && (
        <Layout.Sider
          collapsed={collapsed}
          className='transition-all duration-300 ease-in-out min-w-16! bg-(--sidebar-bg) max-w-62.5'
          width={collapsed ? 64 : 250}
        >
          <MemoizedSidebar collapsed={collapsed} handleToggle={handleToggle} />
        </Layout.Sider>
      )}

      <Layout.Content className='bg-white transition-all duration-300 ease-in-out flex flex-col flex-1 w-full! overflow-hidden'>
        <div className='flex'>
          {isMainPages && (
            <div className='flex justify-center w-37.5 h-screen mt-5'>
              <LogoGlassProIcon width='43px' height='50px' />
            </div>
          )}
          <div className='content'>
            <FunctionalErrorBoundary>
              <MemoizedHeader isLogin={isLogin} />
            </FunctionalErrorBoundary>
            <div
              className={`overflow-hidden box-border flex flex-col flex-1 bg-(--background) ${
                isLogin ? 'mt-0 h-full' : 'mt-17.5 h-[calc(100%-70px)]'
              }`}
            >
              <AppRoutes />
            </div>
          </div>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default DynamicLayout
